/* eslint-disable react/react-in-jsx-scope */
import ContainerWithSidebar from "@/components/Sidebar";
import { profileSidebarMenuList } from "@/config";
import Store from "@/store";
import CommonStore from "@/store/common";
import { UserStore } from "@/store/user";
import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import { autorun } from "mobx";
import { inject, observer } from "mobx-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PaymentPage = inject(
  Store.type.commonStore,
  Store.type.userStore,
)(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  observer((props: any) => {
    const theme = useTheme();

    const commonStore = props[Store.type.commonStore] as CommonStore;
    const userStore = props[Store.type.userStore] as UserStore;
    const navigate = useNavigate();
    useEffect(() => {
      const disposeAutorun = autorun(async () => {
        const userId = userStore.userId;
        if (userId) {
          userStore.fetchMyPayments(userId).catch((error) => {
            console.error("Error fetch my payments:", error);
          });
          commonStore.fetchPaymentMethods().catch((error) => {
            console.error("Error fetch payment methods:", error);
          });
        }
      });
      return () => {
        disposeAutorun();
      };
    }, [userStore]);

    return (
      <ContainerWithSidebar menu={profileSidebarMenuList}>
        <Container
          maxWidth="lg"
          sx={{
            py: "82px",
            [theme.breakpoints.up("lg")]: { maxWidth: "lg", py: "82px" },
          }}
        >
          <Card>
            <Stack spacing={4}>
              <Typography variant="h2" component="h2">
                My Payments
              </Typography>
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => {
                    navigate("/profile/payments/create");
                  }}
                >
                  Add Payment
                </Button>
              </Stack>
              <Grid container spacing={2}>
                {commonStore.paymentMethods
                  .filter((method) =>
                    userStore.myPayments?.find(
                      (payment) =>
                        payment.payment_method_id === method.payment_id,
                    ),
                  )
                  .map((method) => (
                    <Grid item xs={12} key={method.payment_id}>
                      <Stack spacing={2}>
                        <Typography variant="h3" component="h3">
                          {" "}
                          {method.payment_name}
                        </Typography>

                        <Table
                          sx={{
                            minWidth: 650,
                          }}
                        >
                          <TableHead>
                            <TableRow>
                              {method.attributes.map((attribute) => (
                                <TableCell key={attribute.id}>
                                  {attribute.attribute_label}
                                </TableCell>
                              ))}
                              <TableCell>Action</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {userStore.myPayments
                              .filter(
                                (payment) =>
                                  payment.payment_method_id ===
                                  method.payment_id,
                              )
                              .map((payment) => (
                                <TableRow
                                  key={payment.id}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  {method.attributes.map((attribute) => {
                                    const matchAttribute =
                                      payment.payment_attributes.find(
                                        (attr) =>
                                          attr.payment_method_attribute_id ===
                                          attribute.id,
                                      );
                                    return (
                                      <TableCell key={attribute.id}>
                                        {matchAttribute ? (
                                          matchAttribute
                                            .payment_method_attribute
                                            ?.is_image ? (
                                            <Box
                                              component="img"
                                              src={
                                                matchAttribute.attribute_value
                                              }
                                              maxWidth="160px"
                                              maxHeight="160px"
                                              sx={{ objectFit: "cover" }}
                                            />
                                          ) : (
                                            matchAttribute.attribute_value
                                          )
                                        ) : (
                                          "-"
                                        )}
                                      </TableCell>
                                    );
                                  })}
                                  <TableCell>
                                    <Button
                                      color="primary"
                                      onClick={() => {
                                        navigate(
                                          "/profile/payments/" +
                                            payment.id +
                                            "/edit",
                                        );
                                      }}
                                    >
                                      Edit
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </Stack>
                    </Grid>
                  ))}
              </Grid>
            </Stack>
          </Card>
        </Container>
      </ContainerWithSidebar>
    );
  }),
);
export default PaymentPage;
